import React from "react";
import { useTheme } from "../../../contexts/ThemeContext";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
  stepLabels,
}) => {
  const { theme } = useTheme();
  const primaryColor = theme.neutral[600];
  const primaryLightColor = theme.neutral[400];

  return (
    <div className="flex items-center justify-center mb-4 sm:mb-6 md:mb-8 px-2 sm:px-4 overflow-x-auto w-full">
      <div className="flex items-center space-x-1 sm:space-x-2 md:space-x-4 min-w-max">
        {Array.from({ length: totalSteps }, (_, index) => {
          const step = index + 1;
          const isCompleted = step < currentStep;
          const isActive = step === currentStep;

          return (
            <div key={step} className="flex flex-col items-center">
              <div className="flex items-center">
                <div
                  className="relative flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 transition-all duration-300"
                  style={{
                    backgroundColor: isCompleted
                      ? primaryColor
                      : isActive
                      ? "white"
                      : "#f3f4f6",
                    borderColor: isCompleted
                      ? primaryColor
                      : isActive
                      ? primaryColor
                      : "#d1d5db",
                    color: isCompleted
                      ? "white"
                      : isActive
                      ? primaryColor
                      : "#9ca3af",
                    boxShadow: isActive
                      ? `0 4px 14px 0 ${theme.primary[200]}`
                      : "none",
                  }}
                >
                  {isCompleted ? (
                    <span className="text-xs sm:text-sm">✓</span>
                  ) : (
                    <span className="text-xs sm:text-sm font-bold">{step}</span>
                  )}
                  {isActive && (
                    <div
                      className="absolute inset-0 rounded-full animate-ping opacity-20"
                      style={{ backgroundColor: primaryLightColor }}
                    ></div>
                  )}
                </div>
                {step < totalSteps && (
                  <div
                    className="w-8 sm:w-12 md:w-16 lg:w-24 h-0.5 sm:h-1 mx-1 sm:mx-2 rounded-full transition-colors duration-300"
                    style={{
                      backgroundColor: isCompleted ? primaryColor : "#e5e7eb",
                    }}
                  ></div>
                )}
              </div>
              {stepLabels[index] && (
                <span className={`text-xs sm:text-sm mt-1 sm:mt-2 text-center max-w-[60px] sm:max-w-none truncate sm:whitespace-normal ${
                  isActive ? "font-semibold text-gray-900" : "text-gray-500"
                }`}>
                  {stepLabels[index]}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
